import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { primary_color } from '../../../Helper/uiHelper'
import { request } from '../../../Redux/Sagas/requests/api'
import { useHistory } from 'react-router-dom'
import Loader from 'react-loaders'

export const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <Card
      className='content-widget'
      style={{ marginBottom: '1rem', borderRadius: '8px', boxShadow: isOpen ? '0 0px 20px #049FDB44' : '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <CardBody onClick={toggle} style={{ cursor: 'pointer' }}>
        <div className='subtitle1 font-weight-bold d-flex justify-content-between py-1' style={{ color: primary_color }}>
          <span className='p font-weight-bold' style={{ color: primary_color }}>
            {question}
          </span>

          <FontAwesomeIcon icon={isOpen ? faMinus : faPlus} />
        </div>
        <Collapse isOpen={isOpen}>
          <div className='p mt-2' style={{ color: '#8e8e8e', fontWeight: 100 }} dangerouslySetInnerHTML={{ __html: answer }}></div>
        </Collapse>
      </CardBody>
    </Card>
  )
}

const FAQSection = ({ formFieldValue, faqs, setFaqs, additionalSetting, FAQheadingWhenQuery, defaultFAQheading }) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (formFieldValue?.query_id) {
      setLoading(true)
    }
    request('raise-ticket/faqs', 'POST', {
      query_type_id: formFieldValue?.query_type_id,
      query_id: formFieldValue?.query_id,
      pageSize: additionalSetting?.pagination,
      faq_type: additionalSetting?.faq_type,
    }).then((res) => {
      if (res?.data?.data) {
        setFaqs(res?.data?.data)
        setLoading(false)
      }
    })
  }, [formFieldValue?.query_type_id, formFieldValue?.query_id])
  if (loading)
    return (
      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <Loader color='#3f6ad8' type='ball-pulse' />
      </div>
    )

  return (
    <div className='mb-5 content-widget'>
      <h2 className='font-weight-bold ' style={{ color: primary_color, marginBottom: '3rem' }}>
        {faqs?.length > 0 ? (
          <>
            {formFieldValue?.query_id
              ? FAQheadingWhenQuery
                ? FAQheadingWhenQuery?.replace(/<[^>]*>/g, '')
                : 'Here are some frequently asked questions relevant to your query:'
              : defaultFAQheading
              ? defaultFAQheading?.replace(/<[^>]*>/g, '')
              : "Looking for answers? Browse through our FAQ's !"}
          </>
        ) : (
          <>{defaultFAQheading ? defaultFAQheading?.replace(/<[^>]*>/g, '') : "Looking for answers? Browse through our FAQ's !"}</>
        )}
      </h2>
      {faqs.map((item, index) => (
        <FAQItem key={index} question={item.question} answer={item.answer} />
      ))}
      <div className='mt-5'>
        <Button
          className='subtitle1 py-3 font-weight-bold'
          style={{ background: primary_color, borderRadius: '50rem', width: '100%', color: 'white' }}
          onClick={() => {
            history.push('/faq-list')
          }}>
          View All <i class='fa-solid fa-arrow-right ml-2 p font-weight-bold' style={{ color: 'white' }}></i>
        </Button>
      </div>
    </div>
  )
}

export default FAQSection
